import React from 'react';
import PropTypes from 'prop-types';
import { 
  Form, 
  Input, 
  InputNumber, 
  DatePicker, 
  Row, 
  Col, 
  Button, 
  Select, 
} from 'antd';
import TableTimePicker from 'components/form/TableTimePicker.jsx';
import { shortDate } from 'util/DateFormatter.jsx';
import { hasErrors, createOptions, generateRange } from 'util/FormUtils.jsx';
import 'moment/locale/it';
import locale from 'antd/es/date-picker/locale/it_IT';

const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;

class SingleActivityForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false,
    };
  }

  okButton = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.onSubmit(values);
        this.props.form.resetFields();
        this.props.onCancel();
      }
    })
  }

  cancelButton = () => {
    this.props.form.resetFields();
    this.props.onCancel();
  }

  componentDidMount() {
    // To disabled submit button at the beginning.
    // this.props.form.validateFields();
  }

  disabledDate = (current) => {
    // current.hours(0).minute(0).second(0);
    const rangeYears = generateRange(
      this.props.registryInfo.annoAccademico,
      this.props.registryInfo.tipoCDL,
      null,
      this.props.registryInfo.dataChiusuraCopertura
    );
    console.warn('current: ', current, ' range of years:', rangeYears.minDate, '-', rangeYears.maxDate, 'result of check:', current.isSameOrBefore(rangeYears.minDate) || current.isSameOrAfter(rangeYears.maxDate));
    return current && (current.isSameOrBefore(rangeYears.minDate, 'day') || current.isSameOrAfter(rangeYears.maxDate, 'day'));
    
  }

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;
    const rangeyrs = generateRange(
      this.props.registryInfo.annoAccademico,
      this.props.registryInfo.tipoCDL,
      null,
      this.props.registryInfo.dataChiusuraCopertura
    );
    const opts = createOptions(this.props.formeDidScheduled);
    return (
      <Form className="simple-form" onSubmit={this.okButton} layout="vertical">
        <h3>Quando:</h3>
        <Row gutter={16}>
          <Col span={8}>
            <FormItem label="Data">
              {getFieldDecorator('date', { 
                rules: [{ required: true, message: 'Inserire la data dell\'attività didattica'}] 
                })(
                <DatePicker 
                  locale={locale}
                  format={shortDate} 
                  disabledDate={this.disabledDate} 
                  defaultPickerValue={rangeyrs.minDate}
                  placeholder="Data attività"
                />
              )}
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label="Ora inizio">
              {getFieldDecorator('startTime', { 
                rules: [{ required: true, message: 'Inserire ora di inizio dell\'attività didattica'}] 
                })(<TableTimePicker/>)}
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label="Durata (ore)">
              {getFieldDecorator('durata', { 
                rules: [{ required: true, message: 'Inserire la durata dell\'attività' }]
                })(
                <InputNumber step={0.5} min={0} max={12} placeholder="Durata"/>
              )}
            </FormItem>
          </Col> 
        </Row>
        <h3>Dove:</h3>
        <Row gutter={16}>
          <Col span={12}>
            <FormItem label="Modalità">
            {getFieldDecorator('modalita', {
                initialValue: null,
              })(
                  <Select>
                    <Option key="nd" value={null}>Non Definito</Option>
                    <Option key="sinc" value="sincrona in presenza">Sincrona in presenza</Option>
                    <Option key="sinc" value="sincrona online">Sincrona online</Option>
                    <Option key="asinc" value="asincrona">Asincrona</Option>
                  </Select>
              )}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Aula/Piattaforma">
            {getFieldDecorator('aula', { 
                rules: [{ required: true, message: 'Inserire l\'aula o la piattaforma' }]
                })(
                <Input maxLength={40} />
              )}
            </FormItem>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <FormItem label="Sede">
            {getFieldDecorator('sede')(
                <Input maxLength={256} />
              )}
            </FormItem>
          </Col>
        </Row>
        <h3>Cosa:</h3>
        <Row gutter={16}>
          <Col span={24}>
            <FormItem label="Forma Didattica">
            {getFieldDecorator('formaDid', { 
                rules: [{ required: true, message: 'Inserire la forma didattica' }]
                })(
                <Select>
                  {opts}
                </Select>
              )}
            </FormItem>
          </Col>
          <Col span={24}>
            <FormItem label="Argomento">
            {getFieldDecorator('argomento')(
                <TextArea rows={3} maxLength={2000} />
              )}
            </FormItem>
          </Col>
        </Row>
        <div className="bottom-last" style={{ width: '40%' }}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={hasErrors(getFieldsError())}
              style={{ marginRight: '10px' }}
            >
              Conferma
            </Button>
            <Button onClick={this.cancelButton}>Chiudi</Button>
          </div>
      </Form>
    );
  }
}

SingleActivityForm.propTypes = {
  registryInfo: PropTypes.object.isRequired,
  formeDidScheduled: PropTypes.arrayOf(PropTypes.object),
//  registryYear: PropTypes.number.isRequired,
//  registryCDL: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const WrappedSingleActivity = Form.create()(SingleActivityForm);

export default WrappedSingleActivity;
